/**
 * SVG-based text measurement (browser). Consistent metrics for layout + export.
 */

const measureCache = new Map();

function cacheKey(typography, text) {
  return [
    typography.fontFamily,
    typography.fontSize,
    typography.fontWeight,
    typography.fontStyle,
    typography.letterSpacing,
    text,
  ].join('|');
}

function getMeasureSvg() {
  let svg = document.getElementById('__flyer_measure_svg__');
  if (!svg) {
    svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('id', '__flyer_measure_svg__');
    svg.setAttribute('width', '0');
    svg.setAttribute('height', '0');
    svg.style.cssText = 'position:absolute;visibility:hidden;overflow:hidden;width:0;height:0;';
    document.body.appendChild(svg);
  }
  return svg;
}

function buildTextEl(typography, text) {
  const el = document.createElementNS('http://www.w3.org/2000/svg', 'text');
  el.setAttribute('font-family', typography.fontFamily || 'Arial');
  el.setAttribute('font-size', String(typography.fontSize || 12));
  el.setAttribute('font-weight', typography.fontWeight || 'normal');
  el.setAttribute('font-style', typography.fontStyle || 'normal');
  if (typography.letterSpacing) {
    el.setAttribute('letter-spacing', String(typography.letterSpacing));
  }
  el.textContent = text;
  return el;
}

/** @param {import('../sceneGraph/schema').SceneTypography} typography */
export function measureLineWidth(typography, line) {
  const key = cacheKey(typography, line);
  if (measureCache.has(key)) return measureCache.get(key);

  const svg = getMeasureSvg();
  const el = buildTextEl(typography, line);
  svg.appendChild(el);
  let width = 0;
  try {
    const box = el.getBBox();
    width = Math.max(0, box.width || 0);
  } catch {
    width = (typography.fontSize || 12) * String(line).length * 0.52;
  }
  svg.removeChild(el);
  measureCache.set(key, width);
  return width;
}

/** Heuristic measure for Node / fallback (no DOM). */
export function measureLineWidthHeuristic(typography, line) {
  const fs = typography.fontSize || 12;
  const ls = typography.letterSpacing || 0;
  const len = String(line).length;
  const weight = String(typography.fontWeight || '').includes('bold') || Number(typography.fontWeight) >= 600 ? 1.08 : 1;
  return len * fs * 0.52 * weight + ls * Math.max(0, len - 1);
}

export function createMeasureFn(useDom = typeof document !== 'undefined') {
  return useDom ? measureLineWidth : measureLineWidthHeuristic;
}

export function clearMeasureCache() {
  measureCache.clear();
}
